import React, {useState} from "react";
import "../../styles/Accordion.css"
import SpaceL from "../../commons/SpaceL";

function AccordionSmall() {
    const sections = [
        {
            id: "collapseULPS",
            label: "ULPS",
            content:
                <div >
                    <figure className="text-center">
                        <blockquote className="blockquote">
                            <p>
                                <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>ULPS</h1>
                                <br/>
                                <strong>Nuoto libero<br/> + <br/> SPA <br/></strong>
                                <br/>

                            </p>
                        </blockquote>
                    </figure>
                    <table className="table text-center m-auto" style={{width: "20em", backgroundColor: "white"}}>
                        <thead >
                        </thead>
                        <tbody>
                        <tr >
                            <th scope="col" style={{width: "50%"}}>3 mesi</th>
                            <td>390€</td>
                        </tr>
                        <tr>
                            <th scope="row">6 mesi</th>
                            <td>620€</td>
                        </tr>
                        <tr>
                            <th scope="row">Stagionale</th>
                            <td>800€</td>
                        </tr>
                        </tbody>
                    </table>
                </div>,
        },
        {
            id: "collapsePLUS",
            label: "PLUS",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>PLUS</h1>
                            <br/>
                            <strong>Palestra<br/> + <br/> SPA <br/></strong>
                            <br/>

                        </p>
                    </blockquote>
                </figure>
                <table className="table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="col" style={{width: "50%"}}>3 mesi</th>
                        <td>336€</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>528€</td>
                    </tr>
                    <tr>
                        <th scope="row">11 mesi</th>
                        <td>740€</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapseTRIS",
            label: "TRIS",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p className="m-auto">
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>TRIS</h1>
                            <br/>

                            <div className="d-flex flex-wrap justify-content-center">
                                <strong>3 attività a scelta tra:</strong>
                                <ul className="custom-list">
                                    <li>Corso Acquafitness</li>
                                    <li>Corso Nuoto</li>
                                    <li>Corso Fitness</li>
                                    <li>Runnering</li>
                                    <li>Palestra</li>
                                </ul>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="col" style={{width: "50%"}}>3 mesi</th>
                        <td>450€</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>650€</td>
                    </tr>
                    <tr>
                        <th scope="row">11 mesi</th>
                        <td>800€</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapsePOKER",
            label: "POKER",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>POKER</h1>
                            <br/>
                            <strong>Tutti i corsi  di gruppo Fitness di intervallo e sera</strong><br/>
                            <br/>
                        </p>
                    </blockquote>
                </figure>

                <table className="table text-center m-auto" style={{width: "20em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="col" >1 mese</th>
                        <td>80 €</td>
                    </tr>
                    <tr>
                        <th scope="col" >3 mesi</th>
                        <td>216 €</td>
                    </tr>
                    <tr>
                        <th scope="row" >6 mesi</th>
                        <td>384 €</td>
                    </tr>
                    <tr>
                        <th scope="row">11 mesi</th>
                        <td>572 €</td>
                    </tr>
                    </tbody>
                </table>
            </div>,
        },
        {
            id: "collapseSUPER",
            label: "SUPER",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "8em", fontFamily: "Hammersmith One"}}>SUPER</h1>
                            <br/>
                            <div className="d-flex flex-wrap justify-content-center">
                                <strong>1 attività a scelta tra:</strong>
                                <ul className="custom-list">
                                    <li>Corso Acquafitness</li>
                                    <li>Corso Fitness</li>
                                    <li>Corso Nuoto</li>
                                    <li>Runnering</li>
                                    <li>Palestra</li>
                                </ul>
                            </div>
                            <strong>
                                + <br/>
                                Nuoto libero<br/>
                                + <br/>
                                SPA</strong>
                        </p>
                    </blockquote>
                </figure>
                <table className="table text-center m-auto" >
                    <thead >
                    <tr >
                        <th scope="col" ></th>
                        <th scope="col" rowSpan={2} style={{width: "30%", borderTop: "0px"}}>
                            Orario pieno
                            <div style={{fontSize: "13px"}}></div>
                        </th>
                        <th scope="col" style={{width: "40%"}}>
                            Orario ridotto
                            <div style={{fontSize: "11px"}}>(fino alle 18)</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{backgroundColor: "#F8F8F8"}}>
                        <th scope="row">3 mesi</th>
                        <td>360€</td>
                        <td>312€</td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td>570€</td>
                        <td>504€</td>
                    </tr>
                    <tr>
                        <th scope="row">Stagionale</th>
                        <td>880€</td>
                        <td>710€</td>
                    </tr>
                    </tbody>
                </table>
                <br/>
            </div>
        },
        {
            id: "collapseWEEKEND",
            label: "WEEKEND",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>WEEKEND</h1>
                            <span style={{fontSize: "14px"}}>Valida solo il sabato e la domenica</span>
                            <br/>
                            <br/>
                            <strong>Nuoto Libero<br/>
                                + <br/>
                                Palestra<br/>
                                + <br/>
                                SPA</strong>
                            <br/>
                            <div style={{fontSize: "16px"}}>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <br/>
                <table className="table text-center m-auto" style={{width: "10em"}}>
                    <thead >
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row">11 mesi</th>
                        <td>500 €</td>
                    </tr>
                    </tbody>
                </table>

            </div>
        },
        {
            id: "collapseOPEN",
            label: "OPEN",
            content: <div>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <p>
                            <h1 className="d-flex flex-row justify-content-center m-auto" style={{borderBottom: "solid", width: "5em", fontFamily: "Hammersmith One"}}>OPEN</h1>
                            <br/>
                            <strong>Tutto illimitato</strong><br/>
                            <br/>
                            <div style={{fontSize: "16px"}}>
                            </div>
                        </p>
                    </blockquote>
                </figure>
                <table className="table text-center m-auto" style={{maxWidth: "350px"}}>
                    <thead >
                    <tr >
                        <th scope="col" style={{width: "40%"}} ></th>
                        <th scope="col" rowSpan={2} style={{}}>
                            Orario pieno
                        </th>
                        <th scope="col" style={{width: "40%"}}>
                            Orario ridotto
                            <div style={{fontSize: "11px"}}>(fino alle 16)</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row">3 mesi</th>
                        <td >500€</td>
                        <td ></td>
                    </tr>
                    <tr>
                        <th scope="row">6 mesi</th>
                        <td >750€</td>
                        <td ></td>
                    </tr>
                    <tr>
                        <th scope="row">11 mesi</th>
                        <td >1100€</td>
                        <td >876€</td>
                    </tr>
                    </tbody>
                </table>
                <br/>
            </div>,
        }
    ];

    return (
        <div className="accordion m-auto" id="accordionExample">
            {sections.map((section, index) => (
                <div key={section.id} className="accordion-item">
                    <h2 className="accordion-header d-flex flex-row" id={`flush-heading${index}`} style={{ justifyContent: "center", textAlign: "center" }}>
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${index}`} aria-expanded="false" aria-controls={`flush-collapse${index}`}>
                            {section.label}
                        </button>
                    </h2>
                    <div id={`flush-collapse${index}`} className="accordion-collapse collapse" aria-labelledby={`flush-heading${index}`} data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            {section.content}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default AccordionSmall;
